import { Autocomplete, TextField } from "@mui/material";
import React from "react";

function AutocompleteComponent(props) {
  const { data = [], handleSelecteAutoComplete, label } = props;
  return (
    <Autocomplete
      disablePortal
      id="combo-box-demo"
      getOptionLabel={(option) => option.name}
      options={data}
      onChange={(event, newInputValue) => {
        handleSelecteAutoComplete(newInputValue);
      }}
      sx={{ width: "100%" }}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="standard" />
      )}
    />
  );
}

export default AutocompleteComponent;
